import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { debounceTime, fromEvent } from 'rxjs';

@Component({
    selector: 'app-searchbar',
    templateUrl: './searchbar.component.html',
    styleUrl: './searchbar.component.scss',
    standalone: false
})
export class SearchbarComponent {

  @Input() placeholder: string = 'Buscar';
  @Input() clear: boolean = false;
  @Output() emitSearch = new EventEmitter<number>();
  @ViewChild('searchbar') searchbar!: ElementRef;

  ngOnInit() {
    this.searchbar.nativeElement.value = '';
  }

  ngAfterViewInit() {
    console.log(this.clear);
    
    if (this.clear) {
      this.searchbar.nativeElement.value = '';
    }
    fromEvent(this.searchbar.nativeElement, 'input').pipe(
      debounceTime(1500)
    ).subscribe(() => {
      this.search();
    });
  }

  ngOnChanges() {
    if (this.clear) {
      this.searchbar.nativeElement.value = '';
      this.clear = false;
    }
  }

  search() {
    if (this.searchbar.nativeElement.value === '' || this.searchbar.nativeElement.value.trim().length !== 0) {
      this.emitSearch.emit(this.searchbar.nativeElement.value);
    }
  }

  clearInput() {
    this.searchbar.nativeElement.value = '';
  }
}
